<template>
  <div class="quickscan-thanks">
    <h1>Aanvraagverzoek</h1>
    <h2>Dank u wel</h2>

    <quickscan-stepper :current-step="4" :loading="false">
      <p>
        Uw aanvraag is in goede orde ontvangen.
      </p>
      <p v-if="!isPapier">
        Een medewerker zal uw verzoek beoordelen en indien akkoord ontvangt u op het door u ingevoerde
        e-mailadres een uitnodiging om het aanvraagformulier in te vullen.
      </p>
      <p v-else>
        Wij sturen u zo spoedig mogelijk een aanvraag formulier.
      </p>
    </quickscan-stepper>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import QuickscanStepper from '../components/QuickscanStepper';

export default {
  name: 'quickscan-thanks',
  components: {
    QuickscanStepper,
  },
  data: () => ({
    isPapier: false
  }),
  methods: {
  },
  created: function () {
    this.isPapier = this.step3.application.preferedVersion === 'papier';
  },

  computed: {
    ...mapGetters(['step3']),
  },
};
</script>
